
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './IframeComponent.css';

interface IIframeComponentProps extends MappedComponentProperties {
  iframePath?: string;
  useVcaChatParams?: boolean;
  ariaLabel?: string;
  engagementId?: string;
  siteId?: string;
  desktopHeight?: string;
  desktopWidth?: string;
  mobileHeight?: string;
  mobileWidth?: string;
}

export const IframeComponentEditConfig = {
    emptyLabel: 'IframeComponent',
    isEmpty: (props: PropsWithChildren<IIframeComponentProps>) => {
        return !props || !props.iframePath;
    },
};

const IframeComponent = (props: PropsWithChildren<IIframeComponentProps>): JSX.Element => {
    const isAuthor = (window.location.host.indexOf('4502') > -1) || (window.location.host.indexOf('3000') > -1);
    const TEST_ENGAGEMENT_ID = '3870739238';
    const TEST_SITE_ID = '416096';
    const [url, setUrl] = useState<string>(props.iframePath as string);

    function buildVcaUrl(urlString: string, token: string, engagementId: string, siteId: string) {
        const vcaUrl = new URL(urlString);
        vcaUrl.searchParams.set('token', token);
        vcaUrl.searchParams.set('engagementId', engagementId);
        vcaUrl.searchParams.set('siteId', siteId);

        return vcaUrl.toString();
    }
    
    useEffect(() => {
        if (!props.useVcaChatParams) {
            return;
        }

        const tokenValue = new URLSearchParams(window.location.search).get('token') as string;

        setUrl(
            isAuthor ? buildVcaUrl(props.iframePath!, tokenValue, TEST_ENGAGEMENT_ID, TEST_SITE_ID)
                : buildVcaUrl(props.iframePath!, tokenValue, props.engagementId!, props.siteId!),
        );
    }, []);

    return (<div id='iframe-component' className={'IFrameComponent'} tabIndex={0}>
        <style>
            {
                `
                    .IFrameComponent .IFrameComponent__iframe {
                        height: ${props.desktopHeight ? props.desktopHeight: 'auto'};
                        width: ${props.desktopWidth ? props.desktopWidth: '100%'};
                    }
                    @media (max-width: 64rem) {
                        .IFrameComponent .IFrameComponent__iframe {
                            height: ${props.mobileHeight ? props.mobileHeight : 'auto'};
                            width: ${props.mobileWidth ? props.mobileWidth: '100%'};
                        }
                    }
                `
            }
        </style>
        <iframe className={'IFrameComponent__iframe'}
            aria-label={ props.ariaLabel || undefined }
            src={url}/>
    </div>);
};

export default IframeComponent;
